import ProjectContact from '../model/company/projectContact';
import { CollectKeyFromOption } from './interfaces/collect-key-from-option';
import { CollectionHelper } from './collection-helper';
import AddressHelper from './address-helper';
import AddressWithType from '../model/project/address-with-type';

export class CompanyHelper {
  private constructor() {}

  public static constructCollectKeyOptions(
    projectContacts: ProjectContact[]
  ): CollectKeyFromOption[] {
    if (!CollectionHelper.isPopulated(projectContacts)) {
      return [{ id: -1, label: 'Ander adres', addressType: null }];
    }

    const toReturn: CollectKeyFromOption[] = [];
    const seenCompanyIds = new Set<number>();

    for (const projectContact of projectContacts) {
      if (
        projectContact.company != null &&
        CollectionHelper.isPopulated(projectContact.company.addresses)
      ) {
        if (seenCompanyIds.has(projectContact.company.id)) {
          continue;
        }
        for (const address of projectContact.company.addresses) {
          if (address.type === 'primary' || address.type === 'delivery') {
            const toSetLabel = `${
              projectContact.company.regularName
            }, ${AddressHelper.getAddressDisplay(address)}`;

            const duplicateOptionIndex = toReturn.findIndex(
              o => o.label === toSetLabel
            );
            if (duplicateOptionIndex >= 0) {
              const duplicateOption = toReturn[duplicateOptionIndex];
              if (
                address.type === 'primary' &&
                duplicateOption.addressType !== 'primary'
              ) {
                toReturn[duplicateOptionIndex] = this.constructCollectKeyOption(
                  projectContact,
                  toSetLabel,
                  address
                );
                continue;
              }
              if (address.type === 'delivery') {
                continue;
              }
            }

            toReturn.push(
              this.constructCollectKeyOption(
                projectContact,
                toSetLabel,
                address
              )
            );
          }
        }
        seenCompanyIds.add(projectContact.company.id);
      }
    }

    toReturn.push({ id: -1, label: 'Ander adres', addressType: null });
    return toReturn;
  }

  private static constructCollectKeyOption(
    projectContact: ProjectContact,
    label: string,
    address: AddressWithType
  ): CollectKeyFromOption {
    return {
      id: projectContact.company.id,
      label: label,
      addressType: address == null ? null : address.type
    };
  }
}
